import Head from 'next/head';
import React from 'react';
import Styles from './SeguroAuto25.css';
import SeguroAuto25Facilidades from '@/components/organisms/SeguroAuto25Facilidades';
import SeguroAuto25Cotacao from '@/components/organisms/SeguroAuto25Cotacao';
import SeguroAuto25Cobertura from '@/components/organisms/SeguroAuto25Cobertura';
import SeguroAuto25PortalApp from '@/components/organisms/SeguroAuto25PortalApp';
import SeguroAuto25MaoNaRoda from '@/components/organisms/SeguroAuto25MaoNaRoda';
import SeguroAuto25Condicoes from '@/components/organisms/SeguroAuto25Condicoes';
import FaqLPs25 from '@/components/molecules/FaqLPs25';
import SegurosConteudos from '@/components/organisms/SegurosConteudos';

function SeguroAuto25() {
  const faqTitle = 'Saiba mais sobre seguro e confira nossos canais';
  const imgpng = 'assets/seguro-auto-25/perguntas/img-perguntas.jpg';
  const imgwebp = 'assets/seguro-auto-25/perguntas/img-perguntas.webp';
  const imgpngdesk = 'assets/seguro-auto-25/perguntas/img-perguntas-desk.jpg';
  const imgwebpdesk = 'assets/seguro-auto-25/perguntas/img-perguntas-desk.webp';
  const imgalt =
    'Homem sorridente utilizando notebook em casa, representando comodidade na simulação e contratação de seguro de automóvel online com a Santander Financiamentos';
  const linkMostrarTodasPerguntas = 'duvidas-frequentes.html';
  const faqs = [
    {
      pergunta: 'Como comunicar ou acompanhar um sinistro?',
      resposta: `Através do app Santander Auto, disponível para IOS e Android, você pode comunicar e acompanhar o sinistro, realizar o envio de documentos, agendar e realizar vistoria e falar com o analista do processo. Também é possível comunicar e acompanhar o processo de sinistro de forma digital, através do Portal do Segurado ou em nossa Central de Sinistros, disponível de segunda a sexta, das 08:00 às 20:00, através do telefone 0800 201 9500.`,
    },
    {
      pergunta: 'Como solicitar o carro reserva?',
      resposta: `Em casos de roubo e furto, a liberação do carro reserva é realizada após a comunicação do sinistro e apresentação do B.O (Boletim de ocorrência). Em casos de colisão em que o valor dos reparos fique acima do valor da franquia, a liberação é realizada após autorização dos reparos. Para realizar o agendamento da retirada do carro reserva, é necessário entrar em contato com a central de atendimento, através do telefone 0800 201 9500 - opção 4 ou no Whatsapp 55 (31) 97139-1451, disponível de segunda a sexta, das 08h às 20h, e aos sábados, das 08h às 14h. `,
    },
    {
      pergunta: 'Qual a diferença entre Seguro Auto e Seguro Proteção Financeira?',
      resposta: `O Seguro Auto é voltado para o seu veículo, enquanto o seu Seguro Proteção Financeira é pessoal, ou seja, voltado para quem realizar o financiamento do veículo ou bem. `,
    },
    {
      pergunta: 'O que é sinistro?',
      resposta: `Sinistro é quando ocorre um evento em que o bem segurado sofre um acidente ou prejuízo material, como roubo, furto ou colisão.`,
    },
  ];
  return (
    <>
      <Head>
        <title>Seguro Santander Auto | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Seguro Santander Auto: proteção completa para seu veículo e muito mais. Agora, você faz tudo online, sem sair de casa. Aproveite a facilidade e confira!"
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/seguro-santander-auto.html"
        />
        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content="Seguro auto Santander,Seguro para carros financiados,Seguro de carro online,Seguro para motoristas de aplicativo Santander,Seguro de moto Santander,Proteção veicular Santander,Cobertura completa para veículos,Seguro auto com assistência 24h,Benefícios exclusivos Santander Auto,Seguro flexível para veículos,Seguro automotivo personalizado,Atendimento digital Santander Auto,Financiamento de veículo com seguro,Serviços emergenciais para carros,Seguro auto contra roubo e colisão,Seguro auto com carro reserva,Seguro Zurich Santander,Cobertura de vidros automotivos,Seguro auto rápido e fácil,Tranquilidade no trânsito com Santander"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Seguro Santander Auto | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/seguro-santander-auto.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Homem sorridente dirigindo um carro moderno, representando satisfação e segurança com seguro de automóvel da Santander Financiamentos."
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/seguro-auto-25/hero/hero-1440.webp"
        />
        <meta
          property="og:image:alt"
          content="Homem sorridente dirigindo um carro moderno, representando satisfação e segurança com seguro de automóvel da Santander Financiamentos."
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Seguro Santander Auto | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="Homem sorridente dirigindo um carro moderno, representando satisfação e segurança com seguro de automóvel da Santander Financiamentos."
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/seguro-santander-auto.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/seguro-auto-25/hero/hero-1440.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Homem sorridente dirigindo um carro moderno, representando satisfação e segurança com seguro de automóvel da Santander Financiamentos."
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <SeguroAuto25Facilidades />
      <SeguroAuto25Cotacao />
      <SeguroAuto25Cobertura />
      <SeguroAuto25PortalApp />
      {/* <SeguroAuto25MaoNaRoda /> */}
      <SeguroAuto25Condicoes />
      <FaqLPs25
        imgpng={imgpng}
        imgwebp={imgwebp}
        imgpngdesk={imgpngdesk}
        imgwebpdesk={imgwebpdesk}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
        linkMostrarTodasPerguntas={linkMostrarTodasPerguntas}
      />
      <SegurosConteudos />
      <style jsx>{Styles}</style>
    </>
  );
}

export default SeguroAuto25;
